import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const LessonPlanReadSlice = createSlice({
  name: "LessonPlanReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    LessonPlanRead: (state) => {
      state.isLoading = true;
    },
    successLessonPlanRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureLessonPlanRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearLessonPlanRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  LessonPlanRead,
  successLessonPlanRead,
  failureLessonPlanRead,
  clearLessonPlanRead,
} = LessonPlanReadSlice.actions;

export default LessonPlanReadSlice.reducer;
